<template>
  <form @submit.prevent="getList()" method="GET" novalidate>
    <div class="card-body">
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_title"
              >Course Title</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="course_title"
                class="form-control"
                v-model="search.course_title"
                placeholder="Course Title"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="slug">Slug/URL</label>
            <div class="col-md-9">
              <input
                type="text"
                id="slug"
                class="form-control"
                v-model="search.slug"
                placeholder="Slug/URL"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="course_type"
              >Course Type</label
            >
            <div class="col-md-9">
              <multiselect
                name="course_type"
                :options="course_types"
                placeholder="Pick Course Type"
                :searchable="true"
                :multiple="false"
                v-model="search.course_type"
                v-bind:class="{ 'has-error': errors.has('course_type') }"
                class="course_type"
              >
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <button type="submit" class="btn btn-common m-2px">
                <i class="fas fa-search"></i> Search
              </button>
              <button
                type="reset"
                class="btn btn-warning"
                @click="resetFilter()"
              >
                <i class="fas fa-undo"></i> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ["filter"],
  data: () => ({
    course_types: ["Course", "Quiz", "Content"],
    search: {},
  }),

  mounted() {
    this.search = this.filter;
  },
  methods: {
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    async getList() {
      this.$router.push({
        path: this.$route.fullPath,
        query: this.search,
      });
    },
  },
};
</script>
